if (!customElements.get('custom-reviews-swiper')) {
    customElements.define('custom-reviews-swiper', class CustomReviewsSwiper extends HTMLElement {
        constructor() {
            super();
            this.imageSwiper = null;
            this.contentSwiper = null;
            this.imageSwiperContainer = null;
            this.contentSwiperContainer = null;
        }

        connectedCallback() {
            this.imageSwiperContainer = this.querySelector('.custom-reviews-swiper-section__image-swiper');
            this.contentSwiperContainer = this.querySelector('.custom-reviews-swiper-section__content-swiper');
            if (!this.contentSwiperContainer || !this.imageSwiperContainer) return;
            this.initSwiper();
        }

        initSwiper() {
            
            const imageSwiperContainer = document.querySelector('.custom-reviews-swiper-section__image-swiper');
            const autoplayAttr = imageSwiperContainer.getAttribute('data-autoplay');
            const autoplayEnabled = autoplayAttr === 'true';

            let delayAttr = imageSwiperContainer.getAttribute('data-delay');
            let delay = parseInt(delayAttr, 10);
            if (isNaN(delay) || delay <= 0) {
                delay = 3000;
            }

            const autoplayConfig = autoplayEnabled
            ? {
                delay: delay,
                disableOnInteraction: false
                }
            : false;


            this.imageSwiper = new Swiper(this.imageSwiperContainer, {
                effect: 'fade',
                speed: 500,
                fadeEffect: {
                    crossFade: true,
                },
                allowTouchMove: false,
                autoplay: autoplayConfig,
                // breakpoints: {
                //     320: {
                //         allowTouchMove: true,
                //     },
                //     1001: {
                //         allowTouchMove: false,
                //     }
                // }
            });

            const prevBtn = this.querySelector('.swiper-button-prev');
            const nextBtn = this.querySelector('.swiper-button-next');
            this.contentSwiper = new Swiper(this.contentSwiperContainer, {
                allowTouchMove: false,
                speed: 500,
                effect: 'fade',
                autoplay: autoplayConfig,
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                thumbs: {
                    swiper: this.imageSwiper,
                },
                breakpoints: {
                    320: {
                        allowTouchMove: true,
                    },
                    1001: {
                        allowTouchMove: false,
                    }
                }
            })
        }
    });
}